<template>
  <div style="padding: 0 10px 0 10px;">
    <a-modal v-model="showModal" :closable="false" :footer="null" :keyboard="false">
      <p v-if="roomId==22387371" style="text-align: center;"><img src="/ely.png" alt="" style="height: 120px;"></p>
      <p>请输入直播间房间号：</p>
      <div style="margin-bottom: 16px">
        <a-input addon-before="https://live.bilibili.com/" v-model="roomId" type="number" />
      </div>
      <div style="text-align: right;"><a-button @click="start" type="primary">确认</a-button></div>
    </a-modal>
    <template v-if="!showModal">

      <a-row style="margin: 10px 0;">
        <a-col :span="20"><a-alert :message="tips" type="success" /></a-col>
        <a-col :span="4">
          <a-button icon="download" @click="save()" :disabled="songsList.length<=0" type="primary" style="margin-top: 4px;">保存歌单</a-button>
        </a-col>
      </a-row>

      <a-table ref="danmulist" :columns="columns" :data-source="songsList" bordered :pagination="false" :locale="{emptyText: '暂无人点歌'}">
        <template slot="time" slot-scope="text">
          <a-button class="text" @click="copy(text)" type="link">{{text}}</a-button>
        </template>
        <template slot="user" slot-scope="text, record">
          <a-avatar :src="record.avatar" :size="64" />
          <span>{{record.nickname}}</span>
        </template>
        <template slot="song" slot-scope="text">
          <a-button class="text" @click="copy(text)" type="link">{{text}}</a-button>
        </template>
        <template slot="singer" slot-scope="text">
          <a-button class="text" @click="copy(text)" type="link">{{text}}</a-button>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-row>
            <a-col :span="8"><a-button @click="showRawContent(record.danmu)" icon="snippets">原弹幕</a-button></a-col>
            <a-col :span="8">
              <a-dropdown>
                <a-button class="ant-dropdown-link" @click="e => e.preventDefault()" icon="play-circle">搜索播放</a-button>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a @click="goKugouPlay(record)"><icon-font type="icon-kugouyinle" />酷狗音乐</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="goQMusicPlay(record)"><icon-font type="icon-QQyinle" />QQ音乐</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="goNeteasePlay(record)"><icon-font type="icon-wangyiyun" />网易云音乐</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="goBilibiliPlay(record)"><icon-font type="icon-bilibili" />哔哩哔哩</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </a-col>
            <a-col :span="8">
              <a-popconfirm
                  title="确定要删除这条点歌记录吗？"
                  ok-text="删除"
                  cancel-text="取消"
                  @confirm="remove(record)"
              >
                <a-button href="#" type="danger" icon="delete">删除</a-button>
              </a-popconfirm>
            </a-col>
          </a-row>
        </template>
      </a-table>
    </template>
  </div>
</template>

<script>
import { Icon } from 'ant-design-vue'
import { KeepLiveWS, toMessageData } from 'tiny-bilibili-ws/browser'
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4934032_no5nwha3ae.js',
});

const columns = [{
  title: '序号',
  width: 50,
  dataIndex: 'no'
},
  {
    title: '用户',
    width: 100,
    className: 'user',
    dataIndex: 'user',
    scopedSlots: {
      customRender: 'user'
    }
  },
  {
    title: '歌名',
    width: 100,
    dataIndex: 'song',
    scopedSlots: {
      customRender: 'song'
    }
  },
  {
    title: '歌手',
    width: 100,
    dataIndex: 'singer',
    scopedSlots: {
      customRender: 'singer'
    }
  },
  {
    title: '时间',
    width: 130,
    dataIndex: 'time',
    scopedSlots: {
      customRender: 'time'
    }
  },
  {
    title: '操作',
    width: 200,
    scopedSlots: {
      customRender: 'action'
    }
  }
];
export default {
  components: {
    IconFont
  },
  data() {
    return {
      tips: '仅展示包含"点歌"的弹幕，点击文字可复制对应内容',
      roomId: '',
      showModal: true,
      songsList: [],
      columns,
    }
  },
  created() {
    let roomId = ''
    if (localStorage.getItem('roomId')) {
      roomId = localStorage.getItem('roomId')
    } else {
      roomId = 22387371
    }
    const pathRoomId = window.location.pathname.replace('/', '')
    if (pathRoomId) roomId = pathRoomId
    this.roomId = roomId
  },
  methods: {
    async start () {
      this.showModal = false
      const conf = await fetch(`https://api-eo.airmole.cn/api/getBiliveConf?roomId=${this.roomId}`).then(res => res.json())
      const host = this.randomElement(conf.data.host_server_list)
      const live = new KeepLiveWS(this.roomId, {
        url: `wss://${host.host}:${host.wss_port}/sub`,
        key: conf.data.token,
      })

      live.runWhenConnected(() => {
        console.log(`正在监听 ${this.roomId}`) // 连接成功后才会触发
        localStorage.setItem('roomId', this.roomId)
      })

      live.on('heartbeat', (online) => {
        console.log('人气值: ', online)
      })

      live.on('DANMU_MSG', (danmu) => {
        const raw = toMessageData(danmu)
        this.danmuHandler(raw)
      })

      live.on('error', (e) => {
        console.error('错误: ', e)
      })

      live.on('close', () => {
        console.log(`退出监听 ${this.roomId}`)
      })
    },
    danmuHandler (danmuRaw) {
      if (danmuRaw.cmd !== "DANMU_MSG") return
      const content = danmuRaw.info[1]
      const nickname = danmuRaw.info[2][1]
      const avatar = danmuRaw.info[0][15].user.base.face
      let timedata = new Date(danmuRaw.info[9].ts * 1000)
      let time = timedata.toLocaleDateString() + ' ' + timedata.toTimeString().split(' ')[0]
      console.log('danmuRaw', danmuRaw)
      // console.log(`${nickname}：${content}`)
      // 非点歌弹幕
      if (content.indexOf('点歌') === -1) return
      // 跳过黑名单用户的点歌
      const blackUsers = ['伊利专属智能助手']
      if (blackUsers.includes(nickname)) return
      // 处理歌曲信息
      // 处理歌曲信息
      let song = ''
      let singer = ''
      let text = content.replace('点歌', '').replace('排队', '').replace('《', '').replace('》', '')
      if (text.indexOf('-') >= 0) {
        const songInfo = text.split('-')
        if (songInfo.length === 2) {
          song = songInfo[0]
          singer = songInfo[1]
        }
      }
      if ((!song && !singer) && text.indexOf(' ') >= 0) {
        const songInfo = text.split(' ')
        if (songInfo.length === 2) {
          song = songInfo[0]
          singer = songInfo[1]
        }
        if (songInfo.length === 3) {
          song = songInfo[1]
          singer = songInfo[2]
        }
      }

      let songsList = this.songsList
      songsList = songsList.concat({
        song: song,
        singer: singer,
        no: songsList.length + 1,
        nickname: nickname,
        avatar: avatar,
        danmu: content,
        time
      })
      if (songsList.length > 1000) songsList = songsList.slice(-1000) // 只取最新的1000条
      this.songsList = songsList.reverse()
    },
    randomElement(list) {
      return list[Math.floor(Math.random() * list.length)]
    },
    remove(e) {
      const index = e.$index
      let songsList = this.songsList
      if (songsList.length > 1) {
        this.songsList = songsList.splice(index, 1)
      } else {
        this.songsList = []
      }
      this.$message.success('已删除')
    },
    copy(text) {
      console.log('text', text)
      if (text.length <= 0) {
        return
      }
      text = text.replace('点歌', '')
      this.$copyText(text).then(() => {
        this.$message.success('已复制到粘贴板')
      }, () => {
        this.$message.success('未能复制')
      })
    },
    showRawContent (danmu) {
      const h = this.$createElement
      this.$confirm({
        title: '原弹幕',
        content: h('div', {}, [
          h('p', danmu),
        ]),
        cancelText: '关闭',
        okText: '复制',
        onCancel () {},
        onOk: () => {
          this.copy(danmu)
        }
      });
    },
    goKugouPlay (record) {
      const keyword = encodeURI(record.song + ' ' + record.singer)
      window.open(`https://www.kugou.com/yy/html/search.html#searchType=song&searchKeyWord=${keyword}`)
    },
    goQMusicPlay (record) {
      const keyword = encodeURI(record.song + ' ' + record.singer)
      window.open(`https://y.qq.com/n/ryqq/search?t=song&w=${keyword}`)
    },
    goNeteasePlay (record) {
      const keyword = encodeURI(record.song + ' ' + record.singer)
      window.open(`https://music.163.com/#/search/m/?s=${keyword}`)
    },
    goBilibiliPlay (record) {
      const keyword = encodeURI(record.song + ' ' + record.singer)
      window.open(`https://search.bilibili.com/all?keyword=${keyword}`)
    },
    save() {
      const data = [
        ["歌名", "歌手", "点歌用户", "点歌时间"]
      ]
      this.songsList.forEach(element => {
        data.push([element.song, element.singer, element.nickname, element.time])
      })
      const filename = data[1][3] + "点歌记录"
      this.exportCsv(data, filename)
    },
    exportCsv: function(list, name) {
      const newList = list.map(res => res.join(','))
      const data = newList.join(',\n')
      var uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(data);
      var downloadLink = document.createElement("a");
      downloadLink.href = uri;
      downloadLink.download = (name + ".csv") || "点歌记录.csv";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }
}
</script>

<style scoped>

</style>